import { render } from "./MotmMilan.vue?vue&type=template&id=379572f7"
import script from "./MotmMilan.vue?vue&type=script&lang=js"
export * from "./MotmMilan.vue?vue&type=script&lang=js"

import "./MotmMilan.vue?vue&type=style&index=0&id=379572f7&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__